export default "__VITE_ASSET__1d4efbe8__"